"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeRumMonitor = void 0;
const aws_rum_web_1 = require("aws-rum-web");
const monera_app_core_1 = require("@amzn/monera-app-core");
const isomorphic_1 = require("@amzn/monera-app-core/lib/isomorphic");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const getEnvironmentRumConfig = () => {
    if (monera_app_core_1.IS_STAGE_PROD) {
        return {
            sessionSampleRate: 1,
            telemetries: ['performance', 'errors', 'http']
        };
    }
    else {
        return {
            sessionSampleRate: 0.2,
            telemetries: ['errors', 'http']
        };
    }
};
const baseConfig = Object.assign({ endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com', allowCookies: true, enableXRay: true }, getEnvironmentRumConfig());
const APPLICATION_VERSION = '1.0.0';
const APPLICATION_REGION = 'us-east-1';
const initializeRumMonitor = (authConfig, sessionAttributes) => {
    if ((0, monera_app_core_1.isServerSide)()) {
        return null;
    }
    const { requestId } = sessionAttributes;
    let awsRum = null;
    try {
        awsRum = new aws_rum_web_1.AwsRum(authConfig.applicationId, APPLICATION_VERSION, APPLICATION_REGION, Object.assign(Object.assign({}, baseConfig), { guestRoleArn: authConfig.guestRoleArn, identityPoolId: authConfig.identityPoolId, sessionAttributes }));
        (0, metric_helper_1.meterFatals)({
            methodName: 'initializeRumMonitor',
            metricName: 'RUMInitialization',
            requestId,
            success: true
        });
    }
    catch (error) {
        isomorphic_1.LOGGER.error('CloudWatch RUM Monitor failed to initialize:', error.message);
        (0, metric_helper_1.meterFatals)({
            methodName: 'initializeRumMonitor',
            metricName: 'RUMInitialization',
            requestId,
            error: true
        });
    }
    return awsRum;
};
exports.initializeRumMonitor = initializeRumMonitor;
